import React, { Component } from 'react'
import TSelect from '../common/TSelect'
import TButton from '../common/TButton'
import { jsonResponseHandler } from '../../utils/FetchHelper';
import {connect} from "react-redux";
import TInputForm from "../common/TInputForm";
import autobind from 'autobind-decorator'
import {addPrefix} from "../../utils/UriUtil"
import {DAUMBLOG} from "../../constants/Service";

@connect(state => ({}), dispatch => ({
    dispatch
}))
class SidebarSettingForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            optionList : props.optionList,
            initialSelected : props.selected,
            selected: props.selected,
            changed : {},
        };

        this.changeSelection = this.changeSelection.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    changeSelection(property, value) {

        const { selected, changed }= this.state;
        let diff = {};
        diff[property] = value;

        this.setState({
            selected : Object.assign({}, selected, diff),
            changed : Object.assign({}, changed, diff),
        });
    }

    handleSave(callback, failCallback){

        const { dispatch } = this.props;

        fetch(addPrefix("/manage/design/sidebar/setting.json"),
            {
                method: 'put',
                credentials: 'include',
                headers: {'Content-Type':'application/json'},
                body: JSON.stringify(this.state.changed)
            })
            .then(jsonResponseHandler(dispatch))
            .then(r => r.json())
            .then(data => {
                callback();
                this.setState({
                    initialSelected : Object.assign({}, this.state.selected, data.data),
                    selected : Object.assign({}, this.state.selected, data.data),
                    changed : {},
                });
            })
            .catch(e => {
                console.log(e);
                failCallback();
            });
    }

    @autobind
    changeCountValue(propertyName, value, maxValue = 30) {

        const { selected, changed }= this.state;

        if(value > maxValue){
            value = maxValue;
            event.target.value = maxValue;
        }

        if(value < 0){
            value = 1;
            event.target.value = 1;
        }

        const change = { [propertyName] : value};

        this.setState({
            selected : Object.assign({}, selected, change),
            changed : Object.assign({}, changed, change),
        });
    }

    @autobind
    changeLengthValue(propertyName, value, maxValue = 30) {

        const { selected, changed }= this.state;

        if(value > maxValue){
            value = maxValue;
            event.target.value = maxValue;
        }

        if(value < 0){
            value = 3;
            event.target.value = 3;
        }

        const change = { [propertyName] : value};

        this.setState({
            selected : Object.assign({}, selected, change),
            changed : Object.assign({}, changed, change),
        });
    }

    @autobind
    entriesOnRecentChange(value) {this.changeCountValue('entriesOnRecent', value);}

    @autobind
    commentsOnRecentChange(value) {this.changeCountValue('commentsOnRecent', value);}

    @autobind
    noticesOnRecentChange(value) {this.changeCountValue('noticesOnRecent', value);}

    @autobind
    tagsOnTagboxChange(value) {this.changeCountValue('tagsOnTagbox', value, 100);}

    @autobind
    recentEntryLengthChange(value){this.changeLengthValue('recentEntryLength', value, 100);}

    @autobind
    recentCommentLengthChange(value) {this.changeLengthValue('recentCommentLength', value, 200);}

    @autobind
    recentNoticeLengthChange(value) {this.changeLengthValue('recentNoticeLength', value, 100);}

    @autobind
    linkLengthChange(value) {this.changeLengthValue('linkLength', value);}

    @autobind
    archivesOnPageChange(value) {this.changeCountValue('archivesOnPage', value);}

    @autobind
    checkValidation(){

        const { selected }= this.state;

        let ret = true;
        let elementValidationMessage = '';

        if(parseInt(selected.entriesOnRecent) < 1 || parseInt(selected.entriesOnRecent) > 30){ ret = false; elementValidationMessage='최근 글의 설정 값은 1~30까지 설정되어야 합니다'}
        if(parseInt(selected.commentsOnRecent) < 1 || parseInt(selected.commentsOnRecent) > 30){ret = false; elementValidationMessage='최근 댓글의 설정 값은 1~30까지 설정되어야 합니다'}
        if(parseInt(selected.noticesOnRecent) < 1 || parseInt(selected.noticesOnRecent) > 30){ ret = false; elementValidationMessage='최근 공지의 설정 값은 1~30까지 설정되어야 합니다' }
        if(parseInt(selected.tagsOnTagbox) < 10 || parseInt(selected.tagsOnTagbox) > 100){ ret = false; elementValidationMessage='태그의 설정 값은 10~100까지 설정되어야 합니다' }

        if(parseInt(selected.recentEntryLength) < 3 || parseInt(selected.recentEntryLength) > 100){ ret = false; elementValidationMessage='최근 글의 글자값은 3~100까지 설정되어야 합니다' }
        if(parseInt(selected.recentCommentLength) < 3 || parseInt(selected.recentCommentLength) > 200){ ret = false; elementValidationMessage='최근 댓글의 글자값은 3~200까지 설정되어야 합니다' }
        if(parseInt(selected.recentNoticeLength) < 3 || parseInt(selected.recentNoticeLength) > 100){ ret = false; elementValidationMessage='최근 공지의 글자값은 3~100까지 설정되어야 합니다' }
        if(parseInt(selected.linkLength) < 3 || parseInt(selected.linkLength) > 30){ ret = false; elementValidationMessage='링크의 글자값은 3~30까지 설정되어야 합니다' }

        if(!ret) {
            alert(elementValidationMessage);
        }

        return ret;
    }

    render() {

        const { optionList, initialSelected, selected } = this.state;

        return (
            <form className="wrap_set">
                <fieldset>
                    <legend className="screen_out">글 기본 설정</legend>
                    <div className="item_set">
                        최근 글은
                        <TInputForm type="number" min="1" max="30" className="tf_set tf_sidebar" value={selected.entriesOnRecent} onChange={this.entriesOnRecentChange} />
                        개 표시되며
                        <TInputForm type="number" min="3" max="100" className="tf_set tf_sidebar" value={selected.recentEntryLength} onChange={this.recentEntryLengthChange} />
                        글자까지 표시됩니다.
                    </div>
                    <div className="item_set">
                        최근 댓글은
                        <TInputForm type="number" min="1" max="30" className="tf_set tf_sidebar" value={selected.commentsOnRecent} onChange={this.commentsOnRecentChange} />
                        개 표시되며
                        <TInputForm type="number" min="3" max="200" className="tf_set tf_sidebar" value={selected.recentCommentLength} onChange={this.recentCommentLengthChange} />
                        글자까지 표시됩니다.
                    </div>
                    {window.Config.service !== DAUMBLOG &&
                      <div className="item_set">
                          최근 공지는
                          <TInputForm type="number" min="1" max="30" className="tf_set tf_sidebar" value={selected.noticesOnRecent} onChange={this.noticesOnRecentChange} />
                          개 표시되며
                          <TInputForm type="number" min="3" max="100" className="tf_set tf_sidebar" value={selected.recentNoticeLength} onChange={this.recentNoticeLengthChange} />
                          글자까지 표시됩니다.
                      </div>
                    }
                    <div className="item_set">
                        글 보관함은
                        <TInputForm type="number" min="1" max="30" className="tf_set tf_sidebar" value={selected.archivesOnPage} onChange={this.archivesOnPageChange} />
                        개월까지 표시됩니다.
                    </div>
                    <div className="item_set">
                        링크는
                        <TInputForm type="number" min="3" max="30" className="tf_set tf_sidebar" value={selected.linkLength} onChange={this.linkLengthChange} />
                        글자까지 표시됩니다.
                    </div>
                    <div className="item_set">
                        태그는
                        <TInputForm type="number" min="10" max="100" className="tf_set tf_sidebar" value={selected.tagsOnTagbox} onChange={this.tagsOnTagboxChange} />
                        개 표시되며
                        <TSelect defaultClassName={'opt_set opt_sideset10'} selectItem={this.changeSelection} propertyName={"tagboxAlign"} selected={selected} optionList={optionList} />
                        으로 표시됩니다.
                    </div>
                </fieldset>
                <fieldset>
                    <legend className="screen_out">저장 버튼</legend>
                    <TButton onClick={this.handleSave} initialValues={initialSelected} currentValues={selected} checkValidation={this.checkValidation}/>
                </fieldset>
            </form>
        );
    }
}

export default SidebarSettingForm;
